import { formatDateYYYYMMDD } from "../helpers/utils";

export interface SprayProduct {
  id: string;
  treatmentID: string;
  productID: string;
  usageID: string;
  plannedProductQuantity: number;
  plannedProductQuantityUnitID: string;
  additionOrder: number;
  isDirty: boolean;
  plannedSprayTankVolumeL?: number;
  imageURL?: string;
  isSprayProduct: boolean;
}

export const blankSprayProduct: SprayProduct = {
  id: "",
  treatmentID: "",
  productID: "",
  plannedProductQuantity: 0,
  plannedProductQuantityUnitID: "",
  additionOrder: 1,
  isDirty: false,
  plannedSprayTankVolumeL: 2000,
  usageID: "",
  imageURL: "",
  isSprayProduct: true
}

  export interface SprayCampaign {
    id: string;
    type: 'NU' | 'IN' | 'FU' | 'MI' | 'MX'; 
    description: string;
    mainProductID: string;
    farmID: string;
    blockID: string;    
    releasedForExecution: boolean;
    plannedSprayTankVolumeL: number;
    plannedTotalVolumeL: number;
    plannedStartDate: string;
    actualStartDate: string;
    plannedEndDate: string;
    actualEndtDate: string;
    products: SprayProduct[];    
    isDirty?: boolean,
    completed: boolean,
    sprayNotes?: string;
    relatedTreatmentID?: string;
    daysFromRelatedTreatment?: number;
    cultureStageStartID?: string;
    cultureStageEndID?: string;
    cultureID?: string;
    pestID?: string;

  }
  export type SprayExecutedProduct = {
    id: string;
    productID: string;
    quantity: number;
    unitID: string;
    plannedProductQuantity: number;
    plannedProductQuantityUnitID: string;
    isDirty?: boolean;
  }

  export type SprayExecuted = {
    id: string;
    treatmentID: string;
    sprayTankIndex: number;
    blockID: string;
    tractorID: string;  
    sprayerID: string;
    driverID: string;
    preparerID: string;
    volumeL: number;
    startDate: string;
    endDate: string;
    products: SprayExecutedProduct[];
    isDirty?: boolean;
    treatmentDescription?: string;
    treatmentType?: string;
    isSprayProduct?: boolean;
    farmID?: string;
  }
  
  export const blankSprayExecuted: SprayExecuted = {
    id: "",
    treatmentID: "",
    sprayTankIndex: 1,
    blockID: "",
    tractorID: "",  
    sprayerID: "",
    driverID: "",
    preparerID: "",
    volumeL: 2000,
    startDate: "",
    endDate: "",
    products: [],
      isDirty: false,
    treatmentDescription: "",
    treatmentType: "",
  }

 
  export const blankSprayCampaign: SprayCampaign  = {
  id: "",
  description: "",
  mainProductID: "",
  farmID: "",
  blockID: "",
  type: 'MX',
  releasedForExecution: false,
  plannedSprayTankVolumeL: 2000,
  plannedTotalVolumeL: 6000,
  products: [],
  plannedStartDate: formatDateYYYYMMDD(new Date()) || "",
  isDirty: false,
  completed: false,
  actualStartDate: "",
  plannedEndDate: "",
  actualEndtDate: "",
  sprayNotes: "",
  relatedTreatmentID: undefined,
  daysFromRelatedTreatment: 0,
  cultureStageStartID: undefined,
  cultureStageEndID: undefined,

}


export const sprayTankVolumes = [
  { value: '2000', label: '2000 Litres' },
  { value: '1500', label: '1500 Litres' },
  { value: '1000', label: '1000 Litres' },
  { value: '500', label: '500 Litres' },
  { value: '200', label: '200 Litres' },
  { value: '100', label: '100 Litres' },
];

export const sprayTypes = [
  { value: 'NU', label: 'Nutrition' },
  { value: 'IN', label: 'Insecticide' },
  { value: 'FU', label: 'Fongicide' },
  { value: 'MI', label: 'Acaricide' },
  { value: 'MX', label: 'Mixte' }
];
